import { createContext, useContext, useState, useCallback } from 'react';
import ja from './locales/ja.json';
import en from './locales/en.json';

const locales = { ja, en };
const LANG_STORAGE_KEY = 'emh_language';

const LanguageContext = createContext(null);

export function LanguageProvider({ children }) {
  const [language, setLanguageState] = useState(() => {
    try {
      return localStorage.getItem(LANG_STORAGE_KEY) || 'ja';
    } catch {
      return 'ja';
    }
  });

  const setLanguage = useCallback((lang) => {
    setLanguageState(lang);
    try {
      localStorage.setItem(LANG_STORAGE_KEY, lang);
    } catch (e) {
      console.warn('Failed to persist language preference:', e);
    }
  }, []);

  const t = useCallback((key, params) => {
    const translations = locales[language] || locales.ja;
    let value = translations[key];
    if (value === undefined) {
      value = locales.ja[key] || key;
    }
    if (params && typeof value === 'string') {
      Object.entries(params).forEach(([k, v]) => {
        value = value.replace(`{${k}}`, v);
      });
    }
    return value;
  }, [language]);

  return (
    <LanguageContext.Provider value={{ language, setLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useTranslation() {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error('useTranslation must be used within LanguageProvider');
  return ctx;
}
